import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SeoLandingPage from "./pages/SeoLandingPage";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          
          {/* Pages SEO villes / mots-clés La Réunion */}
          <Route path="/:slug" element={<SeoLandingPage />} />

          {/* Fallback */}
          <Route path="*" element={<HomePage />} />
        </Routes>
        <WhatsAppFloat />
      </BrowserRouter>
    </div>
  );
}

export default App;